<!-- @migration-task Error while migrating Svelte code: Can't migrate code with afterUpdate. Please migrate by hand. -->
<script>
    import { scrollToSection } from "../../utils/scroll-to-section";
    import { afterUpdate, onMount } from 'svelte';
    import About from "./ui/About.svelte";
    import Contact from "./ui/Contact.svelte";
    import Intro from "./ui/Intro.svelte";
    import Scheme from "./ui/Scheme.svelte";

    afterUpdate(() => {
        const url = new URL(window.location.href);
        if (url.hash) {
            const sectionId = url.hash.slice(1);
            scrollToSection(sectionId);
        }
    });
</script>

<svelte:head>
	<title>WW Notariusz - Usługi notarialne Wrocław, krzyki, Księże Małe</title>
	<meta 
        name="description" 
        content="Najlepsza kancelaria notarialna we Wrocławiu" 
    />
    <link rel="canonical" href="https://ww-notariusz.pl" />
</svelte:head>

<Intro />
<About />
<Scheme />
<Contact />